module.exports = __webpack_public_path__ + "img/slide-objectview_active.70b2229a.svg";